import React from "react";
import { Button, Card, Col, Form, Input, Row } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { FormInstance } from "antd/lib/form";

interface TicketMetaSectionProps {
  form: FormInstance;
  pageId?: number;
}

const TicketMetaSection: React.FC<TicketMetaSectionProps> = ({
  form,
  pageId,
}) => {
  return (
    <Card
      type="inner"
      title="Item metadata (áp dụng cho tất cả vé)"
      style={{ marginTop: 12 }}
    >
      <Form.List name={["metaData"]}>
        {(metaFields, { add, remove }) => (
          <>
            {metaFields.map((mf, idx) => (
              <Row
                key={mf.key}
                gutter={12}
                align="middle"
                style={{ marginBottom: 12 }}
              >
                <Col xs={4} sm={3} md={2} style={{ textAlign: 'right', paddingRight: 8 }}>{idx + 1}</Col>
                <Col xs={20} sm={9} md={8}>
                  <Form.Item
                    {...mf}
                    name={[mf.name, "name"]}
                    fieldKey={[mf.fieldKey!, "name"]}
                    rules={[{ required: true, message: "Tên thuộc tính" }]}
                    style={{ marginBottom: 0 }}
                  >
                    <Input
                      placeholder="Tên thuộc tính"
                      disabled={(() => {
                        const v = form.getFieldValue([
                          "metaData",
                          mf.name,
                          "name",
                        ]);
                        const s = String(v || "").toUpperCase();
                        return ["GATE", "ZONE", "FLOOR", "SEAT"].includes(s);
                      })()}
                    />
                  </Form.Item>
                </Col>
                <Col xs={20} sm={9} md={10}>
                  <Form.Item
                    {...mf}
                    name={[mf.name, "description"]}
                    fieldKey={[mf.fieldKey!, "description"]}
                    style={{ marginBottom: 0 }}
                  >
                    <Input placeholder="Mô tả (tùy chọn)" />
                  </Form.Item>
                </Col>
                <Col xs={4} sm={3} md={2}>
                  <Button
                    danger
                    icon={<DeleteOutlined />}
                    disabled={(() => {
                      const v = form.getFieldValue([
                        "metaData",
                        mf.name,
                        "name",
                      ]);
                      const s = String(v || "").toUpperCase();
                      return ["GATE", "ZONE", "FLOOR", "SEAT"].includes(s);
                    })()}
                    onClick={() => remove(mf.name)}
                  />
                </Col>
              </Row>
            ))}
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => {
                add({ name: "", description: "" });
                const meta = Array.isArray(form.getFieldValue(["metaData"]))
                  ? form.getFieldValue(["metaData"])
                  : [];
                const withIds = meta.map((m: any, idx: number) =>
                  m && m.__gid ? m : { ...m, __gid: `g_${idx}_${Date.now()}` }
                );
                form.setFieldsValue({ metaData: withIds });
                // Đồng bộ tức thời xuống từng vé để người dùng thấy ngay
                const tickets = Array.isArray(form.getFieldValue(["ticket"]))
                  ? form.getFieldValue(["ticket"])
                  : [];
                const buildKey = (x: any) =>
                  x?.__gid
                    ? `gid:${x.__gid}`
                    : `name:${String(x?.name || "").toUpperCase()}`;
                const nextTickets = tickets.map((t: any) => {
                  const base = Array.isArray(t?.metaData) ? t.metaData : [];
                  const map: Record<string, any> = {};
                  base.forEach((it: any) => {
                    map[buildKey(it)] = it;
                  });
                  withIds.forEach((gm: any) => {
                    const k = buildKey(gm);
                    if (map[k]) {
                      map[k] = {
                        ...map[k],
                        name: gm?.name,
                        description: gm?.description,
                        __gid: gm?.__gid,
                      };
                    } else {
                      map[k] = {
                        name: gm?.name,
                        description: gm?.description,
                        value: "",
                        __gid: gm?.__gid,
                      };
                    }
                  });
                  return { ...t, metaData: Object.values(map) };
                });
                form.setFieldsValue({ ticket: nextTickets });
              }}
              style={{ marginLeft: '8%' }}
            >
              Thêm thuộc tính
            </Button>
          </>
        )}
      </Form.List>
    </Card>
  );
};

export default TicketMetaSection;
